export const colors = [
  '#FA7B7B',
  '#FB9494',
  '#FFB59E',
  '#FFD89E',
  '#FFF7C5',
  '#EBFF9E',
  '#9EFFB9',
  '#C5FFE8',
  '#94FBEA',
  '#9EDAFF',
  '#9EB4FF',
  '#AF9EFF',
  '#CA9EFF',
  '#C8C5FF',
  '#F5C5FF'
];

let cur = -1;
const len = colors.length;

export const getNextColor = () => {
  cur += 1;

  return cur > len - 1 ? colors[cur % len] : colors[cur];
};
